import { useQueryState } from 'nuqs'
import { type ReactNode, useEffect } from 'react'

import IntroductionCard from '@/views/home/components/introduction-card'

import { useAppSession } from '../hooks/useAppSession'

interface Props {
  children: ReactNode
}


/**
 * Có orderurl trên URL → lưu vào session.
 * Không có orderurl → dùng giá trị đã lưu trong session.
 * Cả URL và session đều không có → hiển thị IntroductionCard.
 * Nếu user quét QR mới (orderurl khác) thì useEffect chạy lại và tự ghi đè giá trị cũ.
 */

const AppOrderSession = ({ children }: Props) => {
  const [orderUrl] = useQueryState('ordersrc')
  const sessionOrderUrl = useAppSession((state) => state.orderUrl)
  const setOrderUrl = useAppSession((state) => state.setOrderUrl)

  useEffect(() => {
    if (orderUrl) {
      setOrderUrl(orderUrl)
    }
  }, [orderUrl, setOrderUrl])

  if (import.meta.env.DEV) {
    return children
  }

  if (!orderUrl && !sessionOrderUrl) {
    return <IntroductionCard />
  }

  return children
}

export default AppOrderSession
